import { Paper } from "@mui/material";
import React from "react";

const LineHeader = () => {
  return (
    <Paper
      sx={{
        height: "1.5rem",
        borderRadius: 0,
      }}
    />
  );
};

export default LineHeader;
